import { createContext, useState } from "react";

export const CouponContext = createContext();

export const CouponContextProvider = ({ children }) => {
    const [selectedCoupons, setSelectedCoupons] = useState([]);

    const contextValue = {
        selectedCoupons,
        setSelectedCoupons
    };

    return (
        <CouponContext.Provider value={ contextValue }>
            { children }
        </CouponContext.Provider>
    );
}
